import { Modal, CircularProgress, Box } from '@mui/material'
import { useAppSelector } from '../../redux/hook'
import { ReactElement } from 'react'

interface ILoadingModal {
    open?: boolean
    onClose?: () => void
}
const LoadingModal = (props: ILoadingModal): ReactElement => {
    const open =
        useAppSelector((state) => state.loader.loader) || props.open || false
    return (
        <Modal open={open}>
            <Box
                sx={{
                    margin: 'calc(50vh - 4vh) auto',
                    width: '8vw',
                    outline: 'none',
                    border: 'none',
                }}
            >
                <CircularProgress size="8vw" />
            </Box>
        </Modal>
    )
}

export default LoadingModal
